(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@csnext/cs-client"), require("Vue"), require("vue-class-component"), require("vue-property-decorator"));
	else if(typeof define === 'function' && define.amd)
		define("csform", ["@csnext/cs-client", "Vue", "vue-class-component", "vue-property-decorator"], factory);
	else if(typeof exports === 'object')
		exports["csform"] = factory(require("@csnext/cs-client"), require("Vue"), require("vue-class-component"), require("vue-property-decorator"));
	else
		root["csform"] = factory(root["@csnext/cs-client"], root["Vue"], root["vue-class-component"], root["vue-property-decorator"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__csnext_cs_client__, __WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_vue_class_component__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__) {
return 